import { Component, OnInit, Input, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { BaseComponent } from '../../models/base/base.component';
import { LookupService } from '../../services/lookup.service';
import { FormGroup } from '@angular/forms';
import { NavigationService } from '../../services/navigation.service';
import { FileService } from '../../services/file.service';
import { YesNoNA } from '../../models/enums';
import { DatePipe } from '@angular/common';
import { MessageService } from 'primeng/api';
import { carrierPaymentType } from './order-form.component';
import { environment } from '../../environments/environment';
import { SharedService } from '../../services/shared.service';
import { formatCurrency } from '../helper/currency.utils';

@Component({
  selector: 'order-detail',
  templateUrl: './order-detail.component.html',
  providers: [
    LookupService,
    FileService,
  ]
})
export class OrderDetailComponent extends BaseComponent implements OnInit, OnChanges {
  @Input() model: any = null;
  @Input() showHeader: boolean = true;
  @Input() showVehicles: boolean = true;
  @Input() mode: string = 'order';
  @Input() showModal = true;

  metadata: any = {};
  lookups: any = {};
  isAdmin: boolean = false;

  form: FormGroup = new FormGroup({}, []);
  showBol = false;

  subs = {};

  today = new Date();

  carrierPhones = [];
  pickupPhones = [];
  deliveryPhones = [];
  driverPhones = [];
  driverNames = [];
  businessPhone = null;

  isDownloadingOrder: boolean = false;
  isDownloadingCarrierTerms: boolean = false;

  YesNoNA = YesNoNA;
  cargoLimit = [];
  cargoInsuranceDeductible = [];
  dateOverhaulOrderNumber: number = environment.dateOverhaulOrderNumber;
  isNewRecordForDateOverhual: boolean = false;
  updatedCustomerDocOrder: number = environment.updatedCustomerDocOrder;
  bookedDispatchOrderNumber: number = environment.bookedDispatchOrderNumber;
  isNewBookedOrderNumber: boolean = false;
  isNewCustomerDocOrder: boolean = false;
  pickupPasswordOrderNumber: number = environment.pickupPasswordOrderNumber;
  isShowPickupPassword: boolean = false;
  hubSpotDealOrderNumber: number = environment.hubSpotDealOrderNumber;
  isNewHubSpotDealOrderNumber: boolean = false;

  customerExpectedDeliveryDates = [];
  customerExpectedPickupDates = [];
  pickupNewETADates = [];
  deliveryNewETADates = [];
  sharedServiceClient: SharedService;
  carrierScheduledPickupDates = [];
  carrierScheduledDeliveryDates = [];
  isPaymentTermsReadOnly:boolean = false;
  truckOverhaulOrderNumber:number = environment.truckOverhaulOrderNumber;
  isNewRecordForTruckOverhual:boolean =false;
  isTenderOrder: boolean = false;
  parsedSpecialInstructions: any[] = [];
  formattedSpecialInstructions: string = '';

  constructor(
    private lookupService: LookupService,
    private navigationService: NavigationService,
    private fileService: FileService,
    private datePipe: DatePipe,
    private ref: ChangeDetectorRef,
    private sharedService: SharedService,
    protected messageService: MessageService) {
    super();
    this.sharedServiceClient = sharedService;
  }

  ngOnInit() {
    this.isAdmin = !!localStorage.getItem('isAdmin');
    this.loadLookup('yesNoNa');
    this.loadLookup('yesNoOnly');
    this.loadLookup('reviewRequested');
    this.loadLookup('yesNo');
    this.loadLookup('yesNoPartial');
    this.loadLookup('yesNoNull');
    this.loadLookup('yesNoNaNull');
    this.loadLookup('customerChargedType');
    this.loadLookup('carrierPaymentType');
    this.loadLookup('sources');
    this.loadLookup('paymentTerms');
    this.loadLookup('transportResults');
    this.loadLookup('paymentMethod');
    this.loadLookup('paymentMethodDepositBy');
    this.loadLookup('viewcarrierpaymenttype');
    this.loadLookup('segment');
    this.loadLookup('subsegmentupfitter');
    this.loadLookup('reviewRequested');
    this.loadLookup('customerDocs')
    this.loadLookup('customerDocOptions')
    this.loadLookup('bookedBy')
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['model'] != null && (changes['model'].firstChange || (changes['model'].currentValue != changes['model'].previousValue))) {
      if (this.model != null) {
        this.parsedSpecialInstructions = this.parseSpecialInstructions(this.model?.specialInstructions);
        if (this.model.number && this.model.number > this.dateOverhaulOrderNumber) {
          this.isNewRecordForDateOverhual = true;
        }
        if (this.model.number && this.model.number > this.updatedCustomerDocOrder) {
          this.isNewCustomerDocOrder = true;
        }
        if (this.model.number && this.model.number > this.bookedDispatchOrderNumber) {
          this.isNewBookedOrderNumber = true;
        }
        if (this.model.number && this.model.number > this.truckOverhaulOrderNumber) {
          this.isNewRecordForTruckOverhual = true;
        }
        if (this.model.number && this.model.number > this.pickupPasswordOrderNumber) {
          this.isShowPickupPassword = true;
        }
        if (this.model.number && this.model.number > this.hubSpotDealOrderNumber) {
          this.isNewHubSpotDealOrderNumber = true;
        }
        this.pickupPhones = this.getStringArray(this.model.pickupPhones, ';');
        this.deliveryPhones = this.getStringArray(this.model.deliveryPhones, ';');
        this.carrierPhones = this.getStringArray(this.model.carrierPhones, ';');
        this.businessPhone = this.model.carrierBusinessPhone;
        this.driverNames = this.getStringArray(this.model.driverName,',');
        this.driverPhones = this.sharedService.getDriverPhonesStringArray(this.model.driverPhone);
        this.cargoLimit = this.getStringArray(this.model.cargoInsuranceLimit, ';');
        this.cargoInsuranceDeductible = this.getStringArray(this.model.cargoInsuranceDeductible, ';');
        this.isTenderOrder = this.model?.settings?.isTender;

        let temparr = [];
        let arr = [];
        arr = this.cargoLimit.length > this.cargoInsuranceDeductible.length ? this.cargoLimit : this.cargoInsuranceDeductible;
        for (let index = 0; index < arr.length; index++) {
          let obj = [];
          obj = [this.cargoLimit[index] ? '$ '+ this.cargoLimit[index]+' ' : '- ',this.cargoInsuranceDeductible[index] ? ' $ '+ this.cargoInsuranceDeductible[index] : ' -'];
          temparr.push(obj);
        }
        this.cargoLimit = temparr;
        if (this.isNewRecordForDateOverhual) {
          this.customerExpectedDeliveryDates = this.model?.customerExpectedDeliveryDates;
          this.customerExpectedPickupDates = this.model?.customerExpectedPickupDates;
          this.carrierScheduledPickupDates = this.model?.carrierScheduledPickupDates;
          this.carrierScheduledDeliveryDates = this.model?.carrierScheduledDeliveryDates
          this.pickupNewETADates = this.model?.pickupNewETADates;
          this.deliveryNewETADates = this.model?.deliveryNewETADates;
        }
        if (this.model.dispatchedOn) {
          this.model.dispatchedOn = this.datePipe.transform(this.model.dispatchedOn, 'MM/dd/yy hh:mm a')
        }
        if (this.model.detailMetadata != null) {
          this.metadata = this.model.detailMetadata;
        } else {
          this.metadata = this.model.metadata;
        }
        if (this.model.brokerFeePaidDate) {
          this.model.brokerFeePaidDate = this.datePipe.transform(this.model.brokerFeePaidDate, 'MM/dd/yy', 'UTC');
        }
        if (this.model.paymentTerms == null && this.model?.customerChargedType === 3) {
          if (this.model.priceToCarrier != null && this.model.balanceDue != null && this.model.priceToCarrier <= this.model.balanceDue) {
            // this.isPaymentTermsReadOnly = true;
            if (this.model.carrierPaymentType == carrierPaymentType.Invoice) {
              this.isPaymentTermsReadOnly = false;
            } else {
              this.isPaymentTermsReadOnly = true;
            }

          }
        }
      }
    }
    }



formatCurrency(value: string | number): string {
  return formatCurrency(value);
}


  loadLookup(key: string, force: boolean = false) {
    this.lookupService.get(key, force)
      .subscribe(r => {
        this.lookups[key] = r;
      });
  }

  switchMode(mode: string) {
    this.mode = mode;

    switch (this.mode) {
      case 'order':
        break;
      case 'invoice':
        break;
    }
  }

  close() {
    localStorage.removeItem("items");
    localStorage.removeItem("invoiceOrderNumber");
    this.navigationService.showDetail(false);
  }

  showInvoice() {
    if (this.model?.isBulkUploadInvoiceActive) {
      this.messageService.add(
        this.toast(
          true,
          "Invoice cannot be edited as " +
            this.model?.bulkUploadInvoiceBy +
            " is Bulk Editing"
        )
      );
      return;
    }
    this.navigationService.showDetail(false);
    this.navigationService.setDetail("invoice", this.model.invoiceGuid);
  }

  downloadOrder() {
    this.isDownloadingOrder = true;
    this.fileService.downloadOrder(this.model.guid, 'Order# ' + this.model.number + '.pdf')
      .subscribe(() => {
        this.isDownloadingOrder = false;
        this.ref.markForCheck();
      });
  }

  get anyCustomerContacts(): boolean {
    return this.model?.customerContacts?.length > 0;
  }

  closeEdit(){
    if(this.model.isBulkUploadActive){
      setTimeout(() => {
        this.messageService.add(this.toast(true, 'Order cannot be edited as ' + this.model?.bulkUploadBy + ' is Bulk Dispatching'));
        return;
      }, 100);
    }else{
      this.navigationService.editButton(true);
      this.close();
    }
  }

  downloadCarrierTerms() {
    if (this.isDownloadingCarrierTerms)
      return;

    this.isDownloadingCarrierTerms = true;
    this.ref.markForCheck();

    this.fileService.downloadCarrierTerms(this.model.guid, this.model.includeBoL, this.model.includePort, 'Carrier Terms Order ' + this.model.number + '.pdf', this.model.includeRidgeville)
      .subscribe(() => {
        this.isDownloadingCarrierTerms = false;
        this.ref.markForCheck();
      },
        err => {
          this.isDownloadingCarrierTerms = false;
          this.ref.markForCheck();

          this.messageService.add({ severity: 'error', summary: 'Error occurred' });
        });
  }

}
